// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export type SetLibraryFilterNavIsOpenParameter = {
    isOpen?: boolean;
};

type HandlerType = Handler<SetLibraryFilterNavIsOpenParameter>;

export const DispatchSetIsFilterNavOpen: HandlerType = props => {
    props.dispatch({
        type: "Data/CmsLibrary/SetIsFilterNavOpen",
        isOpen: props.parameter.isOpen,
    });
};

export const chain = [DispatchSetIsFilterNavOpen];

const setLibraryFilterNavIsOpen = createHandlerChainRunner(chain, "SetLibraryFilterNavIsOpen");

export default setLibraryFilterNavIsOpen;
